
import { GameConfig, ItemID, LocationID } from "Data/GameConfig";
import { Button } from "GameObjects/Button";
import type { IItemConfig } from "Interfaces/IItemConfig";
import type { IItemState } from "Interfaces/IItemState";

export class InteriorItemIconGiveQuest extends Button {
    public readonly id: ItemID;

    constructor(data: IItemConfig & IItemState, location: LocationID) {
        super(
            () => { this.playHoverVO(); },
            location + "/" + data.icon_int_give,
            GameConfig.spritesheets[location],
            data.vo.returned,
        );
        this.id = data.id;
        // this.interactive = false;
    }

    public destroy(pOptions?: PIXI.DestroyOptions | boolean) {
        super.destroy(pOptions);
    }
}
